export const USER_DEVICE = 'USER_DEVICE'
